export const BULK = 0.001 // 散装
export const NOTBULK = 1 // 散装
